import { render, staticRenderFns } from "./album.vue?vue&type=template&id=28e2aaaa&scoped=true"
import script from "./album.vue?vue&type=script&lang=js"
export * from "./album.vue?vue&type=script&lang=js"
import style0 from "./album.vue?vue&type=style&index=0&id=28e2aaaa&prod&scoped=true&lang=css"
import style1 from "./album.vue?vue&type=style&index=1&id=28e2aaaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e2aaaa",
  null
  
)

export default component.exports